const ScheduledItemBorder = ({ color }: { color: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="4"
      height="100%"
      viewBox="0 0 4 60"
      fill="none"
      className="h-full"
      preserveAspectRatio="none"
    >
      <rect width="4" height="60" rx="2" fill={color} />
    </svg>
  );
};

export default ScheduledItemBorder;
